/* eslint-disable @typescript-eslint/no-explicit-any */
import React from "react";
import { Image, Text, View, StyleSheet } from "@react-pdf/renderer";

const styles = StyleSheet.create({
  headingWrapper: {
    flexDirection: "row",
    margin: 10,
  },
  brandLogoWrapper: {
    width: "10%",
    flexGrow: 1,
  },
  brandLogo: {
    width: "70px",
    alignSelf: "center",
  },
  billingInfoWrapper: {
    flexGrow: 1,
    width: "90%",
    alignItems: "flex-end",
  },
  billingInfo: {
    fontSize: "8px",
    textAlign: "left",
  },
  billingInfoLabel: {
    fontWeight: "bold",
    fontSize: "9px",
  },
});

const Header = ({ brandLogo, billingInformation }: any) => {
  return (
    <View style={styles.headingWrapper}>
      <View style={styles.brandLogoWrapper}>
        <Image src={brandLogo} style={styles.brandLogo} />
      </View>
      <View style={styles.billingInfoWrapper}>
        <View>
          <Text style={styles.billingInfo}>
            <Text style={styles.billingInfoLabel}>Purchase Order: </Text>{" "}
            {billingInformation?.purchaseOrderNo}
          </Text>
          <Text style={styles.billingInfo}>
            <Text style={styles.billingInfoLabel}>Billing Account: </Text>
            {billingInformation?.billingAccountNo}
          </Text>
          <Text style={styles.billingInfo}>
            <Text style={styles.billingInfoLabel}>Shipping Account: </Text>
            {billingInformation?.shippingAccountNo}
          </Text>
          <Text style={styles.billingInfo}>
            <Text style={styles.billingInfoLabel}>Shipping Address: </Text>
            {billingInformation?.shippingAddress}
          </Text>
          <Text style={styles.billingInfo}>
            <Text style={styles.billingInfoLabel}>Email Address: </Text>
            {billingInformation?.confirmationEmailAddress}
          </Text>
        </View>
      </View>
    </View>
  );
};

export default Header;
